import { notification } from 'antd'
import firebase from 'firebase/app'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyBFH9TrU93SZLuRcrtkv4SzJhiEERjMW7o',
  authDomain: 'onhand-dev.firebaseapp.com',
  databaseURL: 'https://onhand-dev.firebaseio.com',
  projectId: 'onhand-dev',
  appId: '1:918894380926:web:fc3e1279624144f061d52f',
}

firebase.initializeApp(firebaseConfig)
export const firebaseAuth = firebase.auth()

export async function login(email, password) {
  return firebaseAuth.signInWithEmailAndPassword(email, password).catch(error => {
    notification.warning({
      message: error.code,
      description: error.message,
    })
  })
}

export async function register(email, password) {
  return firebaseAuth.createUserWithEmailAndPassword(email, password).catch(error => {
    notification.warning({
      message: error.code,
      description: error.message,
    })
  })
}

export async function currentAccount() {
  let userLoaded = false
  function getCurrentUser(auth) {
    return new Promise((resolve, reject) => {
      if (userLoaded) {
        resolve(firebaseAuth.currentUser)
      }
      const unsubscribe = auth.onAuthStateChanged(user => {
        userLoaded = true
        unsubscribe()
        const getUserData = () => {
          if (user) {
            const mergedUser = Object.assign({}, user, {
              name: user.displayName,
              id: user.uid,
              avatar: user.photoURL,
              isAnonymous: user.isAnonymous,
              email: user.email,
            })
            return mergedUser
          }
          return user
        }
        resolve(getUserData())
      }, reject)
    })
  }
  return getCurrentUser(firebaseAuth)
}

export async function logout() {
  return firebaseAuth.signOut().then(() => true)
}
